export default __webpack_public_path__ + "static/media/meeting.78be9b4a.jpg";